import { Box, MainText } from "app/components/common";
import React from "react";

const SummaryRow = ({ title, result }) => {
  return (
    <Box
      width="100%"
      flexDirection="row"
      justifyContent="space-between"
      paddingVertical="xs"
    >
      <MainText>{title}</MainText>
      <MainText variant="l3-semibold">{result}</MainText>
    </Box>
  );
};

export default SummaryRow;
